<template>
  <div class="vdiIndex">
    <div class="feil_menu">
      <div class="feil_menu_title">VDI</div>
      <div class="feil_menu_item">
        <el-tree
          :data="feilListData"
          node-key="id"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :default-expanded-keys="unfoldArr"
          accordion
          :highlight-current="true"
          ref="tree"
        >
        <span class="span-ellipsis" slot-scope="{ node, data }">
        <span :title="node.label">{{ node.label }}</span>
        </span>
        </el-tree>
      </div>
    </div>
    <div class="feil_main">
      <div class="feil_main_title">{{ this.mainTitle }}</div>
      <div class="feil_main_item" v-if="fileMainItemData&&fileMainItemData.length>0">
        <ul class="feil_main_item_ul">
          <li
            v-for="val in this.fileMainItemData"
            :key="val.id"
            class="feil_main_item_li"
          >
            <div class="content" @click="downFeil(val.fileUrl,val.fileType)">
              <div class="content_icon">
                <img
                  :src="fileImg.ppt"
                  alt="ppt"
                  v-if="val.fileType == 'pptx'"
                />
                <img
                  :src="fileImg.doc"
                  alt="doc"
                  v-else-if="val.fileType == 'doc'"
                />
                <img
                  :src="fileImg.pdf"
                  alt="pdf"
                  v-else-if="val.fileType == 'pdf'"
                />
                <svg-icon
                  icon-class="image"
                  v-else-if="val.fileType == 'jpg' || val.fileType == 'png'"
                />
                <svg-icon icon-class="XLS" v-else-if="val.fileType == 'xlsx'" />
                <svg-icon
                  icon-class="video"
                  v-else-if="val.fileType == 'video'"
                />
                <svg-icon
                  icon-class="video"
                  v-else-if="val.fileType == 'mp4'"
                />
              </div>
              <div class="content_title">
                <p>{{ val.fileName }}</p>
              </div>
              <div class="content_down">
                <svg-icon icon-class="download" v-if="val.fileType != 'link'&&val.fileType != 'video'" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="feil_main_item" v-else>
        <div class="noDetail">
          <svg-icon icon-class="nodeta"/>
          <p>No Data</p>
        </div>
      </div>
      <el-pagination
        layout="prev, pager, next"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getCurrentHost } from '@/utils/index.js'
export default {
  name: "vdiIndex",
  data() {
    return {
      showItem: 1,
      mainTitle: "aDesk Main Slide",
      unfoldArr: [1],
      pagination: {
        page: 0,
        pageSize: 8,
        total: 0,
        data: [],
      },
      fileMainItemData: [],
      defaultProps: {
        children: "children",
        label: "label",
      },
      feilListData: [
        {
          label: "Product Introduction",
          id: 1,
          children: [
            { label: "aDesk Main Slide", child_id: 1, id: 20 },
            { label: "Sangfor aDesk Online Demo", child_id: 2 },
          ],
        },
        {
          label: "Sales Guidance",
          id: 2,
          children: [
            { label: "aDesk Project Guidance", child_id: 3 },
            { label: "VDI & PC TCO Comparison", child_id: 4 },
            { label: "aDesk Sales Scenario", child_id: 5 },
            { label: "Sangfor aDesk Brochure", child_id: 6 },
            { label: "Sangfor aDesk vGPU Solution Brochure", child_id: 7 },
          ],
        },
        {
          label: "Battle Card",
          id: 3,
          children: [
            { label: "Sales Battle Cards", child_id: 8 },
          ],
        },
        {
          label: "Sizing Guide",
          id: 4,
          children: [
            { label: "Sangfor aDesk Hardware Datasheet", child_id: 9 },
            { label: "Sangfor aDesk Sizing Guide", child_id: 10 },
          ],
        },
        {
          label: "Poc Docs",
          id: 5,
          children: [
            {
              label: "Sangfor aDesk Compatibility List of Peripherals",
              child_id: 11,
            },
          ],
        },
        {
          label: "Bidding Doc",
          id: 6,
          children: [
            { label: "Sangfor aDesk Tender Specification", child_id: 12 },
          ],
        },
        {
          label: "Technical Material",
          id: 7,
          children: [
            { label: "Feature List", child_id: 13 },
            { label: "aDesk Solution Whitepaper", child_id: 14 },
            { label: "Partner Development Guidance", child_id: 15 },
          ],
        },
        {
          label: "Training Docs",
          id: 8,
          children: [
            // { label: "Sangfor  aDesk V5.3.3 Video", child_id: 16 },
            // { label: "Sangfor  aDesk V5.4.0 Video", child_id: 17 },
          ],
        },
        {
          label: "Industry",
          id: 9,
          children: [
            { label: "Sangfor aDesk Solution for Hospital", child_id: 18 },
            { label: "Sangfor aDesk Solution for Manufacture", child_id: 19 },
          ],
        },
      ],
      feilIndexData: {
        1: [
          {
            id: 1,
            fileName: "Sangfor VDI Main Slides For Sales.pdf",
            fileUrl:
              "Sangfor VDI Main Slides For Sales.pdf",
            fileType: "pdf",
          },
        ],
        2: [
          {
            id: 1,
            fileName: "Sangfor aDesk online Demo",
            fileUrl: "https://www.youtube.com/watch?v=nq5mXH8E98E",
            fileType: "video",
          },
        ],
        3: [
          {
            id: 1,
            fileName: "VDI Project Guidance.pdf",
            fileUrl:
              "VDI Project Guidance.pdf",
            fileType: "pdf",
          },
        ],
        4: [
          {
            id: 1,
            fileName: "VDI &amp;amp; PC TCO comparison.pdf",
            fileUrl:
              "VDI &amp;amp; PC TCO comparison.pdf",
            fileType: "pdf",
          },
        ],
        5: [
          {
            id: 1,
            fileName: "VDI sales scenario.pdf",
            fileUrl:
              "VDI sales scenario.pdf",
            fileType: "pdf",
          },
        ],
        6: [
          {
            id: 1,
            fileName: "Sangfor VDI Datasheet 20201014.pdf",
            fileUrl:
              "Sangfor VDI Datasheet 20201014.pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName: "Sangfor Virtual Desktop Infrastructure Solutions.pdf",
            fileUrl:
              "Sangfor Virtual Desktop Infrastructure Solutions.pdf",
            fileType: "pdf",
          },
          {
            id: 3,
            fileName: "VDI_brochures_aDesk-STD-200H-s.pdf",
            fileUrl:
              "VDI_brochures_aDesk-STD-200H-s.pdf",
            fileType: "pdf",
          },
          {
            id: 4,
            fileName: "VDI_brochures_aDesk-STD-500.pdf",
            fileUrl:
              "VDI_brochures_aDesk-STD-500.pdf",
            fileType: "pdf",
          },
        ],
        7: [
          {
            id: 1,
            fileName: "Sangfor aDesk VDI vGPU Solution.pdf",
            fileUrl:
              "Sangfor aDesk VDI vGPU Solution.pdf",
            fileType: "pdf",
          },
        ],
        8: [
          {
            id: 1,
            fileName: "citrix competition.pdf",
            fileUrl:
              "citrix competition.pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName: "Sangfor aDesk and Citrix competition analysis .pdf",
            fileUrl:
              "Sangfor aDesk and Citrix competition analysis .pdf",
            fileType: "pdf",
          },
          {
            id: 3,
            fileName: "Sangfor aDesk and HUAWEI competition analysis.pdf",
            fileUrl:
              "Sangfor aDesk and HUAWEI competition analysis.pdf",
            fileType: "pdf",
          },
          {
            id: 4,
            fileName: "Sangfor aDesk and VMware competition analysis.pdf",
            fileUrl:
              "Sangfor aDesk and VMware competition analysis.pdf",
            fileType: "pdf",
          },
        ],
        9: [
          {
            id: 1,
            fileName: "Sangfor VDI Datasheet.pdf",
            fileUrl:
              "Sangfor VDI Datasheet.pdf",
            fileType: "pdf",
          },
        ],
        10: [
          {
            id: 1,
            fileName: "aDesk sizing guide all in one_20200818.xlsx",
            fileUrl:
              "aDesk sizing guide all in one_20200818.xlsx",
            fileType: "xlsx",
          },
        ],
        11: [
          {
            id: 1,
            fileName: "Compatibility List of Peripherals for aDesk.pdf",
            fileUrl:
              "Compatibility List of Peripherals for aDesk.pdf",
            fileType: "pdf",
          },
        ],
        12: [
          {
            id: 1,
            fileName: "Sangfor aDesk tender specification.pdf",
            fileUrl:
              "Sangfor aDesk tender specification.pdf",
            fileType: "pdf",
          },
        ],
        13: [
          {
            id: 1,
            fileName: "aDesk Feature List.pdf",
            fileUrl:
              "aDesk Feature List.pdf",
            fileType: "pdf",
          },
        ],
        14: [
          {
            id: 1,
            fileName: "Sangfor aDesk_whitepapaer.pdf",
            fileUrl:
              "Sangfor aDesk_whitepapaer.pdf",
            fileType: "pdf",
          },
        ],
        15: [
          {
            id: 1,
            fileName: "aDesk partner development guidance .pdf",
            fileUrl:
              "aDesk partner development guidance .pdf",
            fileType: "pdf",
          },
        ],
        16: [
          {
            id: 1,
            fileName: "FINAL VDI 5.3.3 V.3.mp4",
            fileUrl:
              "FINAL VDI 5.3.3 V.3.mp4",
            fileType: "mp4",
          },
        ],
        17: [],
        18: [
          {
            id: 1,
            fileName: "Sangfor VDI Solution for hospital (First Visit).pdf",
            fileUrl:
              "Sangfor VDI Solution for hospital (First Visit).pdf",
            fileType: "pdf",
          },
          {
            id: 2,
            fileName: "Sangfor VDI solution for hospital_brochure.pdf",
            fileUrl:
              "Sangfor VDI solution for hospital_brochure.pdf",
            fileType: "pdf",
          },
        ],
        19: [
          {
            id: 1,
            fileName: "Sangfor adesk manufacture brochur.pdf",
            fileUrl:
              "Sangfor adesk manufacture brochur.pdf",
            fileType: "pptx",
          },
          {
            id: 2,
            fileName: "VDI Case Study for MFG.pptx",
            fileUrl:
              "VDI Case Study for MFG.pptx",
            fileType: "pdf",
          },
        ],
      },
      fileImg: {
        ppt: require("../../../assets/img/ppt.png"),
        doc: require("../../../assets/img/doc.png"),
        pdf: require("../../../assets/img/pdf.png"),
      },
    };
  },
  methods: {
    handleNodeClick(data) {
      if (data.child_id) {
        this.showItem = data.child_id;
        this.mainTitle = data.label;
        this.pagination.total = this.feilIndexData[data.child_id].length;
        this.fileMainItemData = this.feilIndexData[data.child_id];
        this.pagination.data = this.feilIndexData[data.child_id];
        if (this.pagination.total > 8) {
          this.fileMainItemData = this.fileMainItemData.slice(0, 8);
        }
      }else if(data.children&&data.children.length==0){
        this.fileMainItemData =[];
      }
    },
    handleCurrentChange(val) {
      let sliceEnd = val * 8;
      let sliceStart = sliceEnd - 8;
      this.fileMainItemData = this.pagination.data.slice(sliceStart, sliceEnd);
    },
    //初始化渲染
    initRender() {
      if (this.feilIndexData[1].length > 8) {
        this.pagination.total = this.feilIndexData[1].length;
        this.pagination.data = this.feilIndexData[1];
        this.fileMainItemData = this.feilIndexData[1].slice(0, 8);
      } else {
        this.pagination.total = this.feilIndexData[1].length;
        this.pagination.data = this.feilIndexData[1];
        this.fileMainItemData = this.feilIndexData[1];
      }
    },
        //下载
    downFeil(item,type) {
      if(type!='video'){
        var a = document.createElement("a");
        var filename = item;
        a.href =getCurrentHost()+ item;
        a.download = filename;
        a.click();
      }else{
        window.open(item);
      } 
    },
  },
  mounted() {
    this.initRender();
    this.$nextTick(() => {
      this.$refs.tree.setCurrentKey(20);
    });
  },
};
</script>

<style lang="scss" scoped>
.vdiIndex {
  width: 100%;
  padding: 5px 17px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  .feil_menu {
    width: 20%;
    background: #1688e1;
    .feil_menu_title {
      width: 100%;
      padding: 15px 0;
      font-size: 16px;
      font-weight: 600;
      color: #eaf3f4;
    }
  }
  .feil_main {
    width: 79.5%;
    background: #eff6ff;
    .feil_main_title {
      width: 100%;
      height: 46px;
      background: #1688e1;
      line-height: 46px;
      font-size: 16px;
      text-align: left;
      padding: 0 40px;
      color: #eaf3f4;
    }
    .feil_main_item {
      width: 100%;
      height: 680px;
      padding: 10px;
      .feil_main_item_ul {
        width: 100%;
        .feil_main_item_li {
          padding: 10px;
          .content {
            width: 100%;
            display: flex;
            background: #fff;
            padding: 10px 20px;
            border-radius: 8px;
            justify-content: space-between;
            .content_icon {
              width: 4.5%;
              height: 42px;
              margin-right: 15px;
              background: #248fe6;
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 100%;
              }
              .svg-icon {
                font-size: 28px;
                color: #fff;
                font-weight: 600;
              }
            }
            .content_down {
              width: 4%;
              display: flex;
              align-items: center;
              justify-content: center;
              .svg-icon {
                font-size: 24px;
                color: #248fe6;
              }
            }
            .content_title {
              width: 90%;
              display: flex;
              align-items: center;
              font-size: 14px;
              p {
                width: 100%;
                text-align: left;
                color: #248fe6;
                font-weight: 600;
              }
            }
          }
        }
      }
      .noDetail{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .svg-icon{
          font-size: 60px;
        }
        p{
          font-size: 14px;
        }
      }
    }
  }
}
</style>